<template>
  <div class="slice slice--text-with-image">
    <hr v-if="hasSeparator">
    <PrismicRichText v-if="subheading" :field="subheading" />
    <PrismicImage v-if="image" :class="imageComputedClassNames" :field="image" />
    <PrismicRichText v-if="content" :field="content" />
  </div>
</template>

<script>
  import castArray from 'lodash/castArray'
  import PrismicImage from '~/modules/cms/components/prismic/prismic-image'
  import PrismicRichText from '~/modules/cms/components/prismic/rich-text'

  export default {
    name: 'TextWithImageSlice',
    components: {
      PrismicImage,
      PrismicRichText,
    },
    props: {
      slice: {
        default: () => {},
        type: Object,
      },
    },
    computed: {
      content () {
        return this.$get(this.slice, 'primary.content1', null)
      },
      hasSeparator () {
        return this.$get(this.slice, 'primary.separator', 'No') === 'Yes'
      },
      image () {
        return this.$get(this.slice, 'primary.image', null)
      },
      imageAlignment () {
        return this.$get(this.slice, 'primary.align', 'Left') === 'Left' ? 'left' : 'right'
      },
      imageComputedClassNames () {
        return {
          'align-left': this.imageAlignment === 'left',
          'align-right': this.imageAlignment === 'right',
        }
      },
      subheading () {
        const subheading = castArray(this.$get(this.slice, 'primary.subheading', []))

        return subheading.length ? subheading : null
      },
    },
  }
</script>

<style lang="scss" scoped>
  .slice--text-with-image {
    /deep/ {
      img {
        margin-bottom: 0.5rem;
        max-width: 50%;

        &.align-left {
          float: left;
          margin-right: 1.5rem;
        }
        &.align-right {
          float: right;
          margin-left: 1.5rem;
        }
      }
    }
  }
</style>
